import { CardTheme } from '../../types';

export const CARD_DEFAULT_THEME: CardTheme = {
    selectedBorderColor: 'primary.base',
    selectedBorderWidth: 3,
    textColor: 'common.white',
    iconColor: 'primary.base',
    paddingY: 16,
};
